import { apiRequest } from "../core";

export function getGalleryFeed() {
    let url = new URL(process.env.REACT_APP_BACKEND_HOST + "/api/gallery");
    return apiRequest(url);
}

export function getGalleryImages(alias) {
    let url = new URL(process.env.REACT_APP_BACKEND_HOST + `/api/gallery/${alias}`);
    return apiRequest(url);
}